import { getScript } from 'js/utils/scripts.util';
import { useCallback } from 'react';

import * as Types from '../../../types';

export const useDownloadCafSDK = ({
    sdkUrl
}: {
    sdkUrl: string;
}) => {
    return useCallback(async () => {
        const key = '@combateafraude/identity-sdk' as keyof typeof window;

        if (!window[key] as boolean) {
            if (window['@combateafraude/identity-sdk-promise']) {
                await window['@combateafraude/identity-sdk-promise'];
            } else {
                const promise = getScript(sdkUrl);

                window['@combateafraude/identity-sdk-promise'] = promise;

                await promise;
            }
        }

        return window[key] as Types.GeofencingSdkInstance;
    }, [sdkUrl]);
};
